import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useCurrency } from '../utils/useCurrency';
import { XIcon } from 'lucide-react';
const images = ['https://cdn.magicpatterns.com/uploads/x5ni54ojW5khNeKysJievx/mockup_saveoff_45.png', 'https://cdn.magicpatterns.com/uploads/2PpWuCYThDk2x1NNGrhecx/mockup2.png', 'https://cdn.magicpatterns.com/uploads/wNLTpKYXPEnjyyVWoHh14m/mockup3.png'];
export function PricingSection() {
  const [currentImage, setCurrentImage] = useState(0);
  const [showDeclineModal, setShowDeclineModal] = useState(false);
  const {
    formatPrice,
    formatPriceRange,
    isLoading
  } = useCurrency();
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentImage(prev => (prev + 1) % images.length);
    }, 4000); // Change image every 4 seconds
    return () => clearInterval(timer);
  }, []);
  return <section id="pricing-section" className="pt-10 pb-8 px-6 flex flex-col items-center text-center relative overflow-hidden" data-id="element-136">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-copper/5 rounded-full blur-[100px] pointer-events-none" data-id="element-137" />

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="w-full max-w-sm mb-10 rounded-2xl overflow-hidden shadow-[0_20px_40px_-15px_rgba(201,166,107,0.3)] border border-white/50 relative z-10 aspect-square bg-[#F8F5F0]" data-id="element-138">
        <AnimatePresence data-id="element-139">
          <motion.img key={currentImage} src={images[currentImage]} alt="The Audio Sanctuary on devices" className="absolute inset-0 w-full h-full object-contain" initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} transition={{
          duration: 2,
          ease: [0.4, 0, 0.2, 1]
        }} data-id="element-140" />
        </AnimatePresence>
      </motion.div>

      <motion.div initial={{
      opacity: 0
    }} whileInView={{
      opacity: 1
    }} viewport={{
      once: true
    }} id="pricing-value" className="font-inter text-charcoal opacity-80 mb-8 relative z-10 space-y-3 text-sm w-full max-w-sm" data-id="element-141">
        <div className="flex justify-between items-center border-b border-copper/10 pb-2" data-id="element-142">
          <span data-id="element-143">Postpartum therapist session:</span>
          <span className="font-medium" data-id="element-144">
            <span className={`transition-opacity duration-300 ${isLoading ? 'opacity-0' : 'opacity-100'}`} data-id="element-145">
              {formatPriceRange(150, '+')}
            </span>
          </span>
        </div>
        <div className="flex justify-between items-center border-b border-copper/10 pb-2" data-id="element-146">
          <span data-id="element-147">Nervous system coach:</span>
          <span className="font-medium" data-id="element-148">
            <span className={`transition-opacity duration-300 ${isLoading ? 'opacity-0' : 'opacity-100'}`} data-id="element-149">
              {formatPriceRange(200, '+/hr')}
            </span>
          </span>
        </div>

        <div className="flex flex-col items-center pt-4 pb-2" data-id="element-150">
          <span className="text-xs uppercase tracking-widest opacity-60 mb-1" data-id="element-151">
            Total Value
          </span>
          <span className="font-playfair text-4xl text-charcoal/40 line-through decoration-red-400/50 decoration-2" data-id="element-152">
            <span className={`transition-opacity duration-300 ${isLoading ? 'opacity-0' : 'opacity-100'}`} data-id="element-153">
              {formatPrice(350, true)}
            </span>
          </span>
        </div>

        <p className="font-playfair italic text-xl text-copper mt-4" data-id="element-154">
          The Audio Sanctuary Motherhood Pack:
        </p>
      </motion.div>

      {/* Premium Pricing Card */}
      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.5,
      delay: 0.2
    }} className="relative z-10 w-full max-w-sm bg-white/60 backdrop-blur-xl rounded-3xl p-8 shadow-[0_8px_30px_rgba(201,166,107,0.2),inset_0_1px_0_rgba(255,255,255,0.8)] border border-white/80 mb-8 flex flex-col items-center" data-id="element-155">
        {/* Urgency indicator */}
        <div className="flex items-center gap-2 mb-6 bg-red-50 text-red-600 px-3 py-1 rounded-full text-xs font-inter font-semibold tracking-wide border border-red-100" data-id="element-156">
          <span className="relative flex h-2 w-2" data-id="element-157">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75" data-id="element-158"></span>
            <span className="relative inline-flex rounded-full h-2 w-2 bg-red-500" data-id="element-159"></span>
          </span>
          OFFER EXPIRES SOON
        </div>

        <div className="flex flex-col items-center gap-1 mb-6" data-id="element-160">
          <span className="font-inter text-charcoal opacity-40 line-through text-xl font-medium" data-id="element-161">
            <span className={`transition-opacity duration-300 ${isLoading ? 'opacity-0' : 'opacity-100'}`} data-id="element-162">
              {formatPrice(49, true)}
            </span>
          </span>
          <div className="flex items-start gap-1" data-id="element-163">
            <span className="font-playfair text-copper text-7xl font-medium leading-none tracking-tight" data-id="element-164">
              <span className={`transition-opacity duration-300 ${isLoading ? 'opacity-0' : 'opacity-100'}`} data-id="element-165">
                {formatPrice(26.95, true)}
              </span>
            </span>
          </div>
        </div>

        {/* Metallic Badge */}
        <div className="font-inter text-xs font-bold tracking-[0.15em] uppercase py-2 px-6 rounded-full text-white w-full max-w-[200px] mx-auto" style={{
        background: 'linear-gradient(135deg, #7A4A20 0%, #A0652E 35%, #C9A66B 52%, #A0652E 68%, #7A4A20 100%)',
        boxShadow: '0 4px 15px -3px rgba(122, 74, 32, 0.4), inset 0 1px 2px rgba(255,255,255,0.3)',
        textShadow: '0 1px 2px rgba(0,0,0,0.2)'
      }} data-id="element-166">
          45% OFF TODAY
        </div>
      </motion.div>

      <motion.a id="pricing-cta" href="https://www.gemmamama.com/cart/46531684958347:1" target="_blank" rel="noopener noreferrer" whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.5,
      delay: 0.4
    }} className="relative z-10 w-full max-w-sm group block" data-id="element-167">
        <div className="absolute -inset-1 bg-gradient-to-r from-copper via-gold to-copper rounded-full blur opacity-40 group-hover:opacity-75 transition duration-500 group-hover:duration-200 animate-pulse" data-id="element-168" />
        <div className="relative bg-gradient-to-r from-[#B87333] to-[#D4B896] text-white font-inter font-bold text-sm md:text-base py-5 rounded-full shadow-[0_8px_20px_rgba(184,115,51,0.3),inset_0_1px_1px_rgba(255,255,255,0.4)] border border-[#C9A66B]/50 transition-all text-center" data-id="element-169">
          Yes — Add The Audio-Pack to My Order
        </div>
      </motion.a>

      <motion.div initial={{
      opacity: 0
    }} whileInView={{
      opacity: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.5,
      delay: 0.6
    }} className="flex flex-col items-center mt-6 relative z-10" data-id="element-170">
        <p className="font-inter text-charcoal text-xs opacity-60 uppercase tracking-wider font-medium mb-6" data-id="element-171">
          Instant access. No app required. One earbud away.
        </p>

        <button onClick={() => setShowDeclineModal(true)} className="font-inter text-charcoal text-xs opacity-40 hover:opacity-70 transition-opacity underline underline-offset-4" data-id="element-172">
          No thank you — I don't need nervous system support right now.
        </button>
      </motion.div>

      {/* Decline Modal */}
      <AnimatePresence data-id="element-173">
        {showDeclineModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.3
      }} className="fixed inset-0 z-50 flex items-center justify-center px-6" onClick={() => setShowDeclineModal(false)} data-id="element-174">
            <div className="absolute inset-0 bg-charcoal/60 backdrop-blur-sm" data-id="element-175" />
            <motion.div initial={{
          opacity: 0,
          scale: 0.9,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.9,
          y: 20
        }} transition={{
          duration: 0.3,
          ease: 'easeOut'
        }} className="relative bg-[#FDFBF7] rounded-3xl p-8 max-w-sm w-full shadow-[0_20px_60px_rgba(0,0,0,0.3)] border border-white/60" onClick={e => e.stopPropagation()} data-id="element-176">
              <button onClick={() => setShowDeclineModal(false)} className="absolute top-4 right-4 text-charcoal/40 hover:text-charcoal/70 transition-colors" data-id="element-177">
                <XIcon className="w-5 h-5" data-id="element-178" />
              </button>

              <div className="text-center space-y-5" data-id="element-179">
                <span className="text-4xl" data-id="element-180">🤍</span>

                <h3 className="font-playfair text-2xl text-charcoal leading-tight" data-id="element-181">
                  We get it, mama.
                </h3>

                <p className="font-inter text-charcoal/70 text-sm leading-relaxed" data-id="element-182">
                  But tomorrow morning, when the baby wakes up at 4am and your
                  nervous system is already on fire before your feet hit the
                  floor —
                </p>

                <p className="font-playfair italic text-copper text-lg leading-relaxed" data-id="element-183">
                  you'll wish you had something in your ears that could bring
                  you back to yourself in under two minutes.
                </p>

                <div className="w-8 h-[1px] bg-copper/20 mx-auto" data-id="element-184" />

                <p className="font-inter text-charcoal/60 text-xs leading-relaxed" data-id="element-185">
                  No app to open. No video to watch. No guilt.
                  <br data-id="element-186" />
                  Just press play — and breathe.
                </p>

                <motion.a href="https://www.gemmamama.com/cart/46531684958347:1" target="_blank" rel="noopener noreferrer" whileHover={{
              scale: 1.02
            }} whileTap={{
              scale: 0.98
            }} className="block w-full group relative" data-id="element-187">
                  <div className="absolute -inset-1 bg-gradient-to-r from-copper via-gold to-copper rounded-full blur opacity-30 group-hover:opacity-60 transition duration-500 animate-pulse" data-id="element-188" />
                  <div className="relative bg-gradient-to-r from-[#B87333] to-[#D4B896] text-white font-inter font-bold text-sm py-4 rounded-full shadow-[0_8px_20px_rgba(184,115,51,0.3),inset_0_1px_1px_rgba(255,255,255,0.4)] border border-[#C9A66B]/50 text-center" data-id="element-189">
                    Actually — I deserve this. Give me my Sanctuary.
                  </div>
                </motion.a>

                <button onClick={() => setShowDeclineModal(false)} className="font-inter text-charcoal text-[10px] opacity-30 hover:opacity-50 transition-opacity underline underline-offset-4" data-id="element-190">
                  No, I'll keep managing on my own.
                </button>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </section>;
}